// extracted by mini-css-extract-plugin
export default {"container":"CustomPolygonControls_container__GPUhS"};